import { Box, Typography } from "@mui/material";

import { DeploymentType, Latest, Next } from "src/store/api/generatedApi";

import { useTenantTranslation } from "hooks/formatters";
import { MixPriceDiff } from "./MixPriceDiff";
import { RevertableMixButton } from "./RevertableMix";
import { PlanId } from "../boundary/PlanId";
import { Period } from "hooks/periodIndex";

interface Props {
  planId: PlanId;
  mixId: number;
  originalDeploymentMixId?: number;
  deploymentType: DeploymentType;
  startAt: Date;
  endAt: Date;
  planTimeframe: Latest | Next;
  originalPrice: number;
}

export const SupervisorActionCell = ({
  planId,
  mixId,
  originalDeploymentMixId,
  deploymentType,
  startAt,
  endAt,
  planTimeframe,
  originalPrice,
}: Props) => {
  const { t } = useTenantTranslation();
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: 0.5,
        justifyContent: "space-between",
        height: "100%",
        minHeight: 0,
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: 0.5,
          flexShrink: 0,
        }}
      >
        <Typography
          variant="caption"
          sx={{
            color: "text.secondary",
            fontSize: "0.75rem",
            fontWeight: "fontWeightRegular",
          }}
        >
          {t("mix")}: {mixId}
        </Typography>
        <MixPriceDiff
          planId={planId}
          mixId={mixId}
          originalPrice={originalPrice}
          period={1 as Period}
        />
      </Box>
      {originalDeploymentMixId === undefined ? null : (
        <Box sx={{ flexShrink: 0, marginBottom: 1 }}>
          <RevertableMixButton
            mixId={mixId}
            planId={planId}
            deploymentType={deploymentType}
            startAt={startAt}
            endAt={endAt}
            planTimeframe={planTimeframe}
            originalDeploymentMixId={originalDeploymentMixId}
          />
        </Box>
      )}
    </Box>
  );
};
